import { Toast } from '@gafe/common-ui';
import { put } from '@redux-saga/core/effects';

import { TaxableItem } from '@/components/modals/SubmitOrder/types';
import { dateType } from '@/controllers/Activity';
import { OrderController } from '@/controllers/Order';
import { Contact, InputContactInfo } from '@/controllers/ShippingAddress';
import { TaxController } from '@/controllers/Tax';
import { ContactVm, CreateDesignToOrderVm, ReduxAction, ReduxSagaAction } from '@/types';

import { fetchTaskStatusesCards } from '../activities/actions';

import { OrderMetricsActionTypes, OrdersActionTypes } from './action-types';

export const getOrder = (orderId: string): ReduxSagaAction => ({
  type: OrdersActionTypes.FETCH_ORDER.START,
  subtypes: OrdersActionTypes.FETCH_ORDER,
  promise: () => OrderController.fetchOrder(orderId),
});

export const fetchOrderAlertMessage = (orderId: string): ReduxSagaAction => ({
  type: OrdersActionTypes.FETCH_ORDER_ALERT_MESSAGE.START,
  subtypes: OrdersActionTypes.FETCH_ORDER_ALERT_MESSAGE,
  promise: () => OrderController.fetchOrder(orderId),
});

export const createDesignToOrder = (
  order: CreateDesignToOrderVm,
  proposalId: string,
): ReduxAction => ({
  type: OrdersActionTypes.CREATE_DESIGN_TO_ORDER.START,
  proposalId,
  payload: { ...order },
});

export const clearCreatedOrderId = (): ReduxAction => ({
  type: OrdersActionTypes.CREATE_DESIGN_TO_ORDER.CLEAN_UP,
});

export const calculateTax = (
  address: Contact | ContactVm | InputContactInfo,
  taxableItems: TaxableItem[],
  proposalId: string,
): ReduxSagaAction => ({
  type: OrdersActionTypes.CALCULATE_TAX.START,
  subtypes: OrdersActionTypes.CALCULATE_TAX,
  promise: () => TaxController.getTax(address, taxableItems, proposalId),
});

export const clearCalculatedTax = (): ReduxAction => ({
  type: OrdersActionTypes.CALCULATE_TAX.CLEAN_UP,
});

export const fetchAllBucketFilesById = (bucketId: string): ReduxSagaAction => ({
  type: OrdersActionTypes.FETCH_ALL_BUCKETS_FILES_BY_ID.START,
  subtypes: OrdersActionTypes.FETCH_ALL_BUCKETS_FILES_BY_ID,
  promise: () => OrderController.fetchAllBucketFilesById(bucketId),
});

export const setTaskDate = (
  orderId: string,
  dateTaskType: dateType,
  date: string,
  callback: () => void,
): ReduxSagaAction => ({
  type: OrdersActionTypes.SET_TASK_DATE.START,
  subtypes: OrdersActionTypes.SET_TASK_DATE,
  sagaPayload: { orderId, dateTaskType, date, callback },
  promise: () => OrderController.setTaskDate(orderId, dateTaskType, date),
});

export const setTaskDates = (
  orderId: string,
  deliveryDate: {
    value: string | null;
  },
  installDate: {
    value: string | null;
  },
  callback: () => void,
): ReduxAction => ({
  type: OrdersActionTypes.SET_TASK_DATE.START,
  subtypes: OrdersActionTypes.SET_TASK_DATE,
  sagaPayload: { orderId, deliveryDate, installDate, callback },
});

export const scheduleDatesCleanup = (): ReduxAction => ({
  type: OrdersActionTypes.SET_TASK_DATE.CLEAN_UP,
});

export const setRoofInstallComplete = (
  orderId: string,
  isComplete: boolean,
  closeModal: () => void,
): ReduxSagaAction => ({
  type: OrdersActionTypes.SET_ROOF_INSTALL_COMPLETE.START,
  subtypes: OrdersActionTypes.SET_ROOF_INSTALL_COMPLETE,
  promise: () => OrderController.setRoofInstallComplete(orderId, isComplete),
  onSuccess: function* () {
    closeModal();

    const message = isComplete
      ? 'The Installation has been marked as complete.'
      : 'The Installation task has been reopened.';

    Toast({
      closeButton: true,
      dismissive: true,
      message,
      showIcon: true,
      title: 'Success',
      type: 'success',
    });

    yield put(fetchTaskStatusesCards(orderId));
  },
});

export const fetchOrderMetrics = (dateOption: string): ReduxAction => ({
  type: OrderMetricsActionTypes.FETCH_ORDER_METRIC.START,
  subtypes: OrderMetricsActionTypes.FETCH_ORDER_METRIC,
  sagaPayload: {
    dateOption,
  },
});
